import { useCallback, useRef } from 'react';
import { Modal } from 'antd';
import type { ModalFuncProps } from 'antd';
import { useNavigate } from 'react-router-dom';

type ModalInstance = {
    destroy: () => void;
    update: (config: ModalFuncProps) => void;
};

const useNoCreditPopup = () => {
    const navigate = useNavigate();
    const modalRef = useRef<ModalInstance | null>(null);

    const showNoCreditPopUp = useCallback(() => {
        if (modalRef.current) return;

        const app = localStorage.getItem('app') || 'tatva_ai';

        const closeModal = () => {
            modalRef.current?.destroy();
            modalRef.current = null;
        };

        const commonProps: ModalFuncProps = {
            title: 'Credit Expired',
            centered: true,
            onCancel: closeModal,
            afterClose: () => {
                modalRef.current = null;
            },
            okButtonProps: {
                style: {
                    backgroundImage: 'linear-gradient(135deg, #4B22E5, #A553EE)',
                    borderColor: 'transparent',
                },
            },
        };

        if (app === 'zymedelite') {
            modalRef.current = Modal.confirm({
                ...commonProps,
                content: 'Your credits have been exhausted. It will be credited soon.',
                okText: 'Okay',
                onOk: closeModal,
            });
        } else {
            modalRef.current = Modal.confirm({
                ...commonProps,
                content: 'Please subscribe to continue using Tatva AI.',
                okText: 'Upgrade to pro',
                onOk: () => {
                    closeModal();
                    navigate('/my-subscription');
                },
            });
        }
    }, [navigate]);

    return showNoCreditPopUp;
};

export default useNoCreditPopup;